import React from 'react';
import Modal from 'react-modal';
import './css/CreatePlanModal.css'; // Create a CSS file for styling the modal

const CreatePlanModal = ({ isOpen, onClose, onSave, isSaving = false }) => {
    const [planName, setPlanName] = React.useState('');
    const [mergePlan, setMergePlan] = React.useState(false);
    const [localError, setLocalError] = React.useState('');

    React.useEffect(() => {
        if (!isOpen) {
            setPlanName('');
            setMergePlan(false);
            setLocalError('');
        }
    }, [isOpen]);

    const handleSave = async () => {
        if (isSaving) return;
        const trimmedPlanName = String(planName || '').trim();
        if (!trimmedPlanName) {
            setLocalError('Plan name is required.');
            return;
        }
        setLocalError('');
        const didSave = await onSave(trimmedPlanName, mergePlan);
        if (didSave) {
            setPlanName('');
            setMergePlan(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={isSaving ? undefined : onClose}
            contentLabel="Create Plan"
            className="create-plan-modal" // Add a class for custom styling
            overlayClassName="create-plan-overlay" // Add a class for the overlay
            shouldCloseOnOverlayClick={!isSaving}
            shouldCloseOnEsc={!isSaving}
        >
            <h2>Create New Plan</h2>
            {localError && <p className="create-plan-error">{localError}</p>}
            <div>
                <label>
                    Plan Name:
                    <input
                        type="text"
                        value={planName}
                        onChange={(e) => setPlanName(e.target.value)}
                        placeholder="Enter plan name"
                        disabled={isSaving}
                    />
                </label>
            </div>
            <div>
                <label>
                    <input
                        type="checkbox"
                        checked={mergePlan}
                        onChange={(e) => setMergePlan(e.target.checked)}
                        disabled={isSaving}
                    />
                    Merge Plan
                </label>
                <p>
                    Note: A "merge plan" will only copy the game objects.
                    removing: alliance buildings, flags, etc.
                </p>
            </div>
            {isSaving && (
                <div className="create-plan-progress" role="status" aria-live="polite">
                    <span className="create-plan-spinner" aria-hidden="true" />
                    <span>
                        Creating plan and copying tiles. This can take a bit on large maps.
                    </span>
                </div>
            )}
            <div className="create-plan-button-row">
                <button onClick={handleSave} disabled={isSaving}>
                    {isSaving ? 'Creating...' : 'Create'}
                </button>
                <button onClick={onClose} disabled={isSaving}>Cancel</button>
            </div>
        </Modal>
    );
};

export default CreatePlanModal;
